import React from "react";
import PropTypes from "prop-types";
import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, CircularProgress, DialogContent } from "@material-ui/core";

const YamazumiBarInfo = (props) => {
    return (
        <DialogContent>
            <TableContainer>
                <Table size="small" stickyHeader aria-label="sticky table" className={'appTable'}>
                    <TableHead>
                        <TableRow>
                            <TableCell>TM Name</TableCell>
                            <TableCell>Operation</TableCell>
                            <TableCell>Best CT</TableCell>
                            <TableCell>Performance</TableCell>
                            <TableCell>Allocation</TableCell>
                            <TableCell>Allo.MTS</TableCell>
                            <TableCell>POT.PCS</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {props.isLoading ? <TableRow><TableCell colSpan={10}> <CircularProgress /> Loading ...</TableCell></TableRow> : null}
                        {props.data.map((row, index) => {
                            return (
                                <TableRow key={index}>
                                    {index === 0 ? <TableCell rowSpan={props.data.length}>{row.tmName}</TableCell> : null}
                                    <TableCell>{row.oprationName}</TableCell>
                                    <TableCell>{row.bestCT}</TableCell>
                                    <TableCell>{row.performance}%</TableCell>
                                    <TableCell>{row.allocation}%</TableCell>
                                    <TableCell>{row.alloMTS}</TableCell>
                                    <TableCell>{row.potPCS}</TableCell>
                                </TableRow>
                            )
                        })}
                        {(!props.isLoading && props.data.length == 0) ? <TableRow><TableCell colSpan={10}> No data found.</TableCell></TableRow> : null}
                    </TableBody>
                </Table>
            </TableContainer>
        </DialogContent>
    )
}

YamazumiBarInfo.propTypes = {
    data: PropTypes.array.isRequired,
    isLoading: PropTypes.bool
}

export default YamazumiBarInfo;